import { Instagram } from '@mui/icons-material'
import MenuIcon from '@mui/icons-material/Menu'
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography
} from '@mui/material'
import { useState } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import TikTokIcon from './TikTokIcon'

interface Page {
  readonly label: string
  readonly path: string
}

const pages: Page[] = [
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' }
]

const NavBar = () => {
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null)
  const location = useLocation()
  const isHome = location.pathname === '/'

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  return (
    <AppBar
      position='sticky'
      elevation={0}
      sx={{
        backgroundColor: isHome ? 'rgba(12, 15, 13, 0.55)' : 'rgba(20, 26, 22, 0.92)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid',
        borderColor: 'rgba(255, 255, 255, 0.06)'
      }}
    >
      <Container maxWidth='lg'>
        <Toolbar disableGutters sx={{ minHeight: { xs: 56, md: 64 } }}>
          <Typography
            variant='h6'
            noWrap
            component={RouterLink}
            to='/'
            sx={{
              mr: 3,
              display: { xs: 'none', md: 'flex' },
              fontFamily: '"Cormorant Garamond", Georgia, serif',
              fontSize: '1.35rem',
              fontWeight: 500,
              letterSpacing: '0.12em',
              color: 'inherit',
              textDecoration: 'none',
              transition: 'color 0.2s ease',
              '&:hover': { color: 'primary.main' }
            }}
          >
            Catherine Hall
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size='large'
              aria-label='open navigation menu'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={handleOpenNavMenu}
              color='inherit'
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
              PaperProps={{
                sx: {
                  backgroundColor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'rgba(255,255,255,0.07)',
                  mt: 1
                }
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.label}
                  onClick={handleCloseNavMenu}
                  component={RouterLink}
                  to={page.path}
                >
                  <Typography textAlign='center' color='text.primary'>
                    {page.label}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Typography
            variant='h6'
            noWrap
            component={RouterLink}
            to='/'
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: '"Cormorant Garamond", Georgia, serif',
              fontSize: '1.2rem',
              fontWeight: 500,
              letterSpacing: '0.08em',
              color: 'inherit',
              textDecoration: 'none'
            }}
          >
            Catherine Hall
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, gap: 0.5 }}>
            {pages.map((page) => (
              <Button
                key={page.label}
                component={RouterLink}
                to={page.path}
                onClick={handleCloseNavMenu}
                sx={{
                  my: 1,
                  px: 2,
                  color: location.pathname === page.path ? 'primary.main' : 'text.secondary',
                  display: 'block',
                  fontSize: '0.9rem',
                  letterSpacing: '0.06em',
                  '&:hover': { color: 'primary.main', backgroundColor: 'rgba(69, 154, 106, 0.08)' }
                }}
              >
                {page.label}
              </Button>
            ))}
          </Box>

          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <IconButton
              aria-label='Instagram'
              size='small'
              target='_blank'
              rel='noopener noreferrer'
              href='https://www.instagram.com/theviolince/'
              sx={{
                color: 'text.secondary',
                transition: 'color 0.2s ease',
                '&:hover': { color: 'primary.main' }
              }}
            >
              <Instagram fontSize='small' />
            </IconButton>
            <IconButton
              aria-label='TikTok'
              size='small'
              sx={{
                width: 32,
                height: 32,
                color: 'text.secondary',
                transition: 'color 0.2s ease',
                '&:hover': { color: 'primary.main' }
              }}
              target='_blank'
              rel='noopener noreferrer'
              href='https://www.tiktok.com/@theviolince'
            >
              <TikTokIcon color='currentColor' />
            </IconButton>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
export default NavBar
